import React from 'react';
import { GetServerSideProps } from 'next';
import { HeadSection } from 'components/HeadSection';
import { ServerProduct } from 'types';
import { ServiceContainer } from 'helpers';
import {
  ProductListWithFilter,
  SearchIntents,
} from 'components/desktop/organisms';
import { useRouter } from 'next/router';

export interface SearchProps {
  serverProducts: ServerProduct;
}

const Search: React.FunctionComponent<SearchProps> = ({
  serverProducts,
}: SearchProps) => {
  const router = useRouter();
  const { query } = router;
  const filterParams = query.query
    ? {
        keyword: query.query,
      }
    : query;
  return (
    <>
      <HeadSection />
      <SearchIntents keyword={query.query as string} />
      <ProductListWithFilter
        marginTop="s16"
        filterParams={filterParams}
        productListParams={query}
        serverProducts={serverProducts?.products || []}
      />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  try {
    const query = context.query;
    const { discoveryService } = new ServiceContainer(
      (context.req as any).tenantEnv,
    );
    const variables = {
      terminalCode: (context.req as any).tenantEnv.terminal,
      itemsPerPage: 40,
      ...query,
    };
    const response = await discoveryService.search(variables);
    return {
      props: {
        serverProducts: {
          products: response.result.products,
        },
      },
    };
  } catch {
    return {
      props: {
        serverProducts: null,
      },
    };
  }
};

export default Search;
